import { render, staticRenderFns } from "./template.vue?vue&type=template&id=5471489d&scoped=true&"
import script from "@/Components/Global/SubmitButton/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/SubmitButton/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/SubmitButton/style.scss?vue&type=style&index=0&id=5471489d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471489d",
  null
  
)

export default component.exports